import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Youtube, Building2, Linkedin } from 'lucide-react';



const Footer = () => {
      const currentYear = new Date().getFullYear();

      return (
            <footer className="relative bg-[#0B0F19] text-slate-400 overflow-hidden border-t border-slate-800/50 pt-16 sm:pt-20 md:pt-28 lg:pt-40">
                  <div className="max-w-7xl mx-auto px-6 lg:px-8 pb-28 md:pb-24 lg:pb-32 relative z-10">
                        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-8 mb-12 md:mb-16 lg:mb-24 relative z-10">
                              {/* Brand Section - Left Side */}
                              <div className="lg:col-span-5 flex flex-col justify-between">
                                    <div>
                                          <Link to="/" className="inline-flex items-center gap-3 mb-6">
                                                <img src="/logo-mark.png" alt="" width="48" height="48" loading="lazy" decoding="async" className="w-12 h-12 rounded-xl hover:opacity-90 transition-opacity" />
                                                <span className="text-2xl font-bold text-white tracking-tight">Ilmversity</span>
                                          </Link>
                                          <p className="text-slate-300 leading-relaxed mb-8 max-w-sm">
                                                Ilmversity works alongside you, streamlining operations, enhancing learning, and accelerating your institution's growth from admission to graduation.
                                          </p>

                                          {/* Social Links */}
                                          <div className="flex items-center gap-4">
                                                {[
                                                      { icon: Facebook, href: 'https://www.facebook.com/ILMVERSITY/', label: 'Ilmversity on Facebook' },
                                                      { icon: Twitter, href: 'https://x.com/ILMVERSITY', label: 'Ilmversity on X' },
                                                      { icon: Youtube, href: 'https://www.youtube.com/channel/UCNqnekn8pxmFs18zM2qIuNw', label: 'Ilmversity on YouTube' },
                                                      { icon: Linkedin, href: 'https://www.linkedin.com/company/ilmversity/', label: 'Ilmversity on LinkedIn' },
                                                      { icon: Building2, href: 'https://www.crunchbase.com/organization/ilmversity', label: 'Ilmversity on Crunchbase' }
                                                ].map((social, index) => (
                                                      <a
                                                            key={index}
                                                            href={social.href}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            aria-label={social.label}
                                                            className="w-10 h-10 rounded-full bg-slate-900 border border-slate-800 flex items-center justify-center hover:bg-blue-600 hover:border-blue-600 hover:text-white transition-all duration-300"
                                                      >
                                                            <social.icon className="w-4 h-4" aria-hidden="true" />
                                                      </a>
                                                ))}
                                          </div>

                                          {/* App Store Buttons */}
                                          <div className="flex flex-col sm:flex-row gap-4 mt-8">
                                                <a
                                                      href="https://apps.apple.com/us/app/ilmversity/id1125550364"
                                                      target="_blank"
                                                      rel="noopener noreferrer"
                                                      className="block w-36 opacity-80 hover:opacity-100 transition-opacity"
                                                >
                                                      <img
                                                            src="/assets/badges/app-store.svg"
                                                            width="144" height="48" loading="lazy" decoding="async"
                                                            alt="Download on the App Store"
                                                            className="w-full"
                                                      />
                                                </a>
                                                <a
                                                      href="https://play.google.com/store/apps/details?id=com.granjur.ilmversityteachers"
                                                      target="_blank"
                                                      rel="noopener noreferrer"
                                                      className="block w-36 opacity-80 hover:opacity-100 transition-opacity"
                                                >
                                                      <img
                                                            src="/assets/badges/google-play.svg"
                                                            width="144" height="48" loading="lazy" decoding="async"
                                                            alt="Get it on Google Play"
                                                            className="w-full"
                                                      />
                                                </a>
                                          </div>
                                    </div>
                              </div>

                              {/* Links Section - Right Side */}
                              <div className="lg:col-span-7 grid grid-cols-2 sm:grid-cols-3 gap-8 lg:pl-12">
                                    {/* Product Links */}
                                    <div>
                                          <h3 className="text-white font-semibold mb-6">Product</h3>
                                          <ul className="space-y-4">
                                                {[
                                                      { name: 'School Management', path: '/school-management-system' },
                                                      { name: 'Features', path: '/features' },
                                                      { name: 'AI Capabilities', path: '/ai-school-management' },
                                                      { name: 'LMS', path: '/best-learning-management-system-lahore-karachi-pakistan' },
                                                      { name: 'Security', path: '/security' },
                                                      { name: 'Download App', path: '/download-app' }
                                                ].map((link) => (
                                                      <li key={link.name}>
                                                            <Link to={link.path} className="text-sm hover:text-blue-400 transition-colors">
                                                                  {link.name}
                                                            </Link>
                                                      </li>
                                                ))}
                                          </ul>
                                    </div>

                                    {/* Company Links */}
                                    <div>
                                          <h3 className="text-white font-semibold mb-6">Company</h3>
                                          <ul className="space-y-4">
                                                {[
                                                      { name: 'About Us', path: '/about-us' },
                                                      { name: 'Why Ilmversity', path: '/why-ilmversity' },
                                                      { name: 'Success Stories', path: '/case-studies' },
                                                      { name: 'Resources', path: '/resources' }
                                                ].map((link) => (
                                                      <li key={link.name}>
                                                            <Link to={link.path} className="text-sm hover:text-blue-400 transition-colors">
                                                                  {link.name}
                                                            </Link>
                                                      </li>
                                                ))}
                                          </ul>
                                    </div>

                                    {/* Support Links */}
                                    <div>
                                          <h3 className="text-white font-semibold mb-6">Support</h3>
                                          <ul className="space-y-4">
                                                {[
                                                      { name: 'Contact Us', path: '/contact' },
                                                      { name: 'Request Demo', path: '/request-free-trial' },
                                                      // { name: 'Help Center', path: '/faq' },
                                                      { name: 'UAE Schools', path: '/school-management-system-uae' },
                                                      { name: 'Oman Schools', path: '/school-management-system-oman' },
                                                      { name: 'Saudi Schools', path: '/school-management-system-saudi-arabia' }
                                                ].map((link) => (
                                                      <li key={link.name}>
                                                            <Link to={link.path} className="text-sm hover:text-blue-400 transition-colors">
                                                                  {link.name}
                                                            </Link>
                                                      </li>
                                                ))}
                                          </ul>
                                    </div>
                              </div>
                        </div>

                        {/* Massive Background Text with Reflection */}
                        <div className="absolute bottom-0 md:bottom-[-5%] left-1/2 -translate-x-1/2 w-full flex flex-col items-center pointer-events-none select-none z-0">
                              <div className="relative">
                                    {/* Main Text */}
                                    <span className="text-[20vw] lg:text-[18vw] leading-none font-black text-transparent bg-clip-text bg-gradient-to-b from-blue-500/25 to-blue-600/5 tracking-tighter whitespace-nowrap">
                                          ilmversity
                                    </span>

                                    {/* Reflection Effect */}
                                    <div className="absolute top-[82%] left-0 w-full transform scale-y-[-1] opacity-60 blur-[1px]">
                                          <span className="text-[20vw] lg:text-[18vw] leading-none font-black text-transparent bg-clip-text bg-gradient-to-b from-blue-500/50 via-blue-600/20 to-transparent tracking-tighter whitespace-nowrap">
                                                ilmversity
                                          </span>
                                    </div>

                                    {/* Bottom Glow / Floor Effect */}
                                    <div className="absolute bottom-[-10px] left-0 w-full h-[8vw] lg:h-[6vw] bg-gradient-to-t from-[#0B0F19] via-[#0B0F19]/90 to-transparent z-10"></div>
                              </div>
                        </div>
                  </div>

                  {/* Bottom Bar - Full Width Outside Container */}
                  <div className="border-t border-slate-800/50 bg-[#0B0F19]/40 backdrop-blur-md relative z-20">
                        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-8 flex flex-col md:flex-row justify-between items-center gap-4">
                              <p className="text-sm text-slate-300">
                                    &copy; {currentYear} Ilmversity. All rights reserved.
                              </p>
                              <div className="flex items-center gap-6">
                                    <Link to="/terms-of-service" className="text-sm text-slate-300 hover:text-cyan-400 transition-colors">
                                          Terms of Service
                                    </Link>
                                    <Link to="/privacy" className="text-sm text-slate-300 hover:text-cyan-400 transition-colors">
                                          Privacy Policy
                                    </Link>
                                    <Link to="/cookie-policy" className="text-sm text-slate-300 hover:text-cyan-400 transition-colors">
                                          Cookie Policy
                                    </Link>
                              </div>
                        </div>
                  </div>
            </footer>
      );
};

export default Footer;

